<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "M4Status",
  props: {
    size: String,
    variant: String
  },
  computed: {
    classes() {
      let classes = ["m4status"];
      if (this.size) {
        classes.push("m4status--" + this.size);
      }
      if (this.variant) {
        classes.push("m4status--" + this.variant);
      }
      return classes;
    }
  }
};
</script>
